import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { bindActionCreators } from 'redux';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { catalogBibShape, libraryShape } from '@bibliocommons/bc-prop-types';
import { selectCurrentLibrary } from 'app/selectors/LibrarySelector';
import { selectCatalogBib } from 'app/selectors/catalogBibs/CatalogBibSelector';
import StackMapActions from 'app/actions/StackMapActions';
import { trackHoldingsWayfinderView as trackHoldingsWayfinderViewAction } from 'app/actions/AnalyticsGa4Actions';
import { UI_COMPONENT_TYPE, METADATA_CATEGORY_TYPE } from 'app/constants/AnalyticsGa4Constants';
import StackMapLink from './StackMapLink';

export class StackMapLinkContainer extends React.PureComponent {
  trackShelfMapClick = shelfMapText => {
    const { bibItem, catalogBib, trackHoldingsWayfinderView } = this.props;

    // Note: `catalogBib` will be in Redux state only when this component is rendered on the Bib Page.
    trackHoldingsWayfinderView({
      bibId: catalogBib?.get('metadataId'),
      ui: {
        ui_component_type: UI_COMPONENT_TYPE.LINK_TEXT,
        ui_component_label: shelfMapText
      },
      metadata: {
        metadata_category_type: METADATA_CATEGORY_TYPE.HOLDINGS_RESOURCE_ITEM_ID,
        metadata_value: bibItem.get('itemId')
      },
      location: {
        location_id: bibItem.getIn(['branch', 'code']),
        location_name: bibItem.getIn(['branch', 'name'])
      }
    });
  };

  render() {
    return <StackMapLink {...this.props} trackShelfMapClick={this.trackShelfMapClick} />;
  }
}

StackMapLinkContainer.propTypes = {
  bibItem: ImmutablePropTypes.map.isRequired,
  catalogBib: catalogBibShape,
  currentLibrary: libraryShape.isRequired,
  stackMapActions: PropTypes.objectOf(PropTypes.func).isRequired,
  handleClick: PropTypes.func,
  trackHoldingsWayfinderView: PropTypes.func.isRequired,
  intl: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  catalogBib: selectCatalogBib(state),
  currentLibrary: selectCurrentLibrary(state)
});

const mapDispatchToProps = dispatch => ({
  stackMapActions: bindActionCreators(StackMapActions, dispatch),
  trackHoldingsWayfinderView: bindActionCreators(trackHoldingsWayfinderViewAction, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(StackMapLinkContainer));
